import { useEffect } from 'react';
import './ai-textarea.styles.scss';
import useResize from '../../../hooks/resize.hook';
import AIToolbar from '../ai-toolbar';

/**
 * AITextarea component
 * @param {function} onResize
 * @param {function} onChange
 * @param {boolean} hideToolbar
 * @param {object} props
 * @returns {JSX.Element}
 */
const AITextarea = ({ onResize, onChange, onUpdate, value, hideToolbar = false, ...props }) => {
  const textareaRef = useResize({ 
    onResize
  });

  const updateHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 2}px`;
    }
  }

  useEffect(() => {
    updateHeight();
  }, [value, textareaRef.current, textareaRef.current?.value]);

  return (
    <div className='ai-textarea'>
      <div className='textarea-container'>
        <textarea
          ref={textareaRef}
          {...props}
          onChange={onChange}
          value={value}
        />
        {!hideToolbar && (
          <div className='toolbar-wrapper bg-white radius-4 pb-1'>
            <AIToolbar
              inputRef={textareaRef}
              onUpdate={onUpdate}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default AITextarea;
